import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import Panel from '@cybs-ui/components/lib/panel';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { putDataInDevCenterDataStore } from '../../../../../app/store';
import '../css/side-panel.css';
import {replaceOrUpdateBrandName} from '../../../../../libs/common-library';


const SidePanel = () => {
    marked.setOptions({
      gfm: true,
      breaks: true,
    })
    var nodeClickCheck = useSelector(state => state.rhsReducer.nodeClickCheck)
    var clickedNode = useSelector(state => state.rhsReducer.clickedNode)
    var jsTree = useSelector(state => state.rhsReducer.jsTree);
    var responseTree = useSelector(state => state.rhsReducer.responseTree);
    var pathParams = useSelector(state => state.rhsReducer.pathParameters);
    var queryParams = useSelector(state => state.rhsReducer.queryParameters);
    var headerParams = useSelector(state => state.rhsReducer.headerParameters);
    var description = "";
    var additionalInformation = "";
    var tree, treeItemValue;
    var treeFieldArray = [];
    if(clickedNode){
      var value = clickedNode;
      var fieldArray = value.split('-');
      if(fieldArray[0]=='request' || fieldArray[0]== 'requestexpanded'){
        if(fieldArray[1] == 'Query')
        {
          tree = queryParams;
        }
        else if(fieldArray[1] == 'Header')
        {
          tree = headerParams;
        }
        else if(fieldArray[1] == 'Path')
        {
          tree = pathParams;
        }
        else{
          tree = jsTree;
        }
      }
      else{
        tree = responseTree;
      }
      for(var i=2; i<fieldArray.length; i++){
        for(var fieldIndex in tree){
          if(tree[fieldIndex]['value']){
            treeItemValue = tree[fieldIndex]['value'];
          }
          else if(tree[fieldIndex]['name']){
            treeItemValue = tree[fieldIndex]['name'].replaceAll('-','!');
          }
          treeFieldArray = treeItemValue.split('-');
          if(treeFieldArray[i-2] == fieldArray[i]){
            if(i==fieldArray.length-1){
              description = tree[fieldIndex]['description'];
              additionalInformation = tree[fieldIndex]['additionalInformation'];
            }
            else{
              tree = tree[fieldIndex]['children'];
            }
            break;
          }
        }
      }
      var fieldName = fieldArray[fieldArray.length-1];
      var result = fieldName.replace( /([A-Z])/g, " $1" );
      var title = result.charAt(0).toUpperCase() + result.slice(1).replaceAll('!','-').replaceAll('*','_');
    }

    return(
        <Panel
        dataTest="info-panel"
          isOpen={nodeClickCheck}
          i18n={{
            title: title
          }}
          onClosePanel={() => { 
              putDataInDevCenterDataStore({type: 'UPDATE_NODE_CLICK_CHECK', nodeClickCheck: false});
          }
        }
        >
          <div>
            <br/>
            {clickedNode && <p dangerouslySetInnerHTML={{__html:replaceOrUpdateBrandName(DOMPurify.sanitize(marked(description)))}}></p>}
            {clickedNode && additionalInformation && additionalInformation.length && <p dangerouslySetInnerHTML={{__html:replaceOrUpdateBrandName(DOMPurify.sanitize(marked(additionalInformation)))}}></p>}
          </div>
        </Panel>
    )
}

export default SidePanel;
